import React, { useState } from "react";
import MainContainer from "../../../layout/MainContainer";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputBase,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import IosSwitchMain from "../../../components/iosSwitchMain";
import IosSwitch from "../../../components/iosSwitch";
import CancelEventModal from "../../../Modals/cancelEvent";
import GenerateLink from "../../../Modals/generateLink";
import BookingHistory from "../../manageCustomers/bookingHistory";
import FilterMenu from "../../../components/filterMenu";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function PreviewOfferDetail() {
  const location = useLocation();
  const { state } = location;
  const offerType = state?.type || "RESTAURANT";
  console.log(state, "state");

  const [selectedReason, setSelectedReason] = React.useState("");
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  const [openModal, setOpenModal] = React.useState(false);
  const [openModal2, setOpenModal2] = React.useState(false);

  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };


  const [selectedGroups, setSelectedGroups] = useState<string[]>([]);
  const groupOptions = [
    { label: "Field 1", value: "10" },
    { label: "Field 2", value: "20" },
    { label: "Field 3", value: "30" },
    { label: "Field 4", value: "40" },
  ];
  const [searchTerm, setSearchTerm] = useState("");
  const filteredOptions = groupOptions.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleGroupChange = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectedGroups(typeof value === "string" ? value.split(",") : value);
  };
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };
  return (
    <>
      <MainContainer>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1 className="back_arrow">
              {" "}
              <IconButton onClick={() => goBack()}>
                {" "}
                <ArrowBackIcon />{" "}
              </IconButton>{" "}
              View Offer
            </h1>
          </div>
          <div className="right_s">
            <Select
              multiple
              displayEmpty
              className="dropse"
              value={selectedGroups}
              onChange={handleGroupChange}
              input={<InputBase />}
              renderValue={(selected) => {
                if (selected.length === 0) return <span>Export CSV</span>;
                return groupOptions
                  .filter((opt) => selected.includes(opt.value))
                  .map((opt) => opt.label)
                  .join(", ");
              }}
              MenuProps={{
                PaperProps: { style: { maxHeight: 300, padding: 0 } },
              }}
            >
              <Box px={2} pt={1} pb={1}>
                <TextField
                  fullWidth
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                  variant="standard"
                  autoFocus
                />
              </Box>

              {filteredOptions.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  className="multi_check_select"
                >
                  <Checkbox checked={selectedGroups.includes(option.value)} />
                  <ListItemText primary={option.label} />
                </MenuItem>
              ))}
            </Select>
          </div>
        </div>
        <div className="cards view_page prvw_ofr prvw_ofr_detail">
          <h2>Image Upload</h2>
          <ul className="imgs_mn">
            <li>
              <figure>
                <img src="/static/images/preview1.png" alt="icon" />
                <figcaption>
                  <img src="/static/images/delete_icon.svg" alt="icon" />
                </figcaption>
              </figure>
            </li>
            <li>
              <figure>
                <img src="/static/images/preview2.png" alt="icon" />
                <figcaption>
                  <img src="/static/images/delete_icon.svg" alt="icon" />
                </figcaption>
              </figure>
            </li>
            <li>
              <figure>
                <img src="/static/images/preview3.png" alt="icon" />
                <figcaption>
                  <img src="/static/images/delete_icon.svg" alt="icon" />
                </figcaption>
              </figure>
            </li>
          </ul>
          <Box
            className="custom_tabs2 offer_manage_tab mt_40 mb_30"
            sx={{ width: "100%" }}
          >
            <Tabs
              className="custom_tabs_links"
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                label={
                  offerType === "EXPERIENCE" ? (
                    <>Experience</>
                  ) : offerType === "EVENT" ? (
                    <>Events</>
                  ) : (
                    <>Dining</>
                  )
                }
                {...a11yProps(0)}
              />
              <Tab label="Booking History" {...a11yProps(1)} />
            </Tabs>
            <div className="btn_flex">
              <IosSwitch />
              {selectedReason === "value2" ? (
                <Button className="btn btn_grey">Refund Initiated</Button>
              ) : (
                <></>
              )}
              {offerType === "EVENT" ? (
                <Button
                  className="btn btn_danger"
                  onClick={() => setOpenModal(true)}
                >
                  Cancel Event
                </Button>
              ) : (
                <></>
              )}
              <FilterMenu />
              <Button className="btn btn_primary">
                {" "}
                <img src="/static/images/edit_icon.svg" alt="icon" /> Edit
                Details
              </Button>
              
                <Button
                  className="btn btn_grey"
                  onClick={() =>
                       navigate(`/manage-offer/preview-offer-detail/add-user?offerType=${offerType}`)

                  }
                >
                  {" "}
                  Add User
                </Button>
             
            </div>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <div className="section_title">
              <div className="lt">
                <h2>The Residence Tunis</h2>
              </div>
            </div>
            <div className="rstrnt_flx">
              <div className="rstrnt_lst">
                <p>Badge</p>
                <h3>Dinner & Games Night</h3>
              </div>
              <div className="rstrnt_lst">
                <p>Subtitle</p>
                <h3>The Residence Tunis</h3>
              </div>
              <div className="rstrnt_lst">
                <p>Groups</p>
                <h3>The Butterfly Effect</h3>
              </div>
              <div className="rstrnt_lst">
                <p>Tag</p>
                <h3>Breakfast</h3>
              </div>
              <div className="rstrnt_lst">
                <p>Offer Display Start Period</p>
                <h3>26-Jun-2025</h3>
              </div>
              <div className="rstrnt_lst">
                <p>Offer Display End Period</p>
                <h3>28-Jun-2025</h3>
              </div>
              {offerType !== "EXPERIENCE" && offerType !== "EVENT" && (
                <div className="rstrnt_lst">
                  <p>Advance Booking Period</p>
                  <h3>3 Week</h3>
                </div>
              )}

              {offerType === "EXPERIENCE" ? (
                <>
                  <div className="rstrnt_lst">
                    <p>End Date</p>
                    <h3>12-06-2025</h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>End Time</p>
                    <h3>12:00 PM</h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>Whats App Number</p>
                    <h3>+91 98765246</h3>
                  </div>
                </>
              ) : offerType === "EVENT" ? (
                <>
                  <div className="rstrnt_lst">
                    <p>Type</p>
                    <h3>Paid</h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>Member Price</p>
                    <h3>AED 1500</h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>Non-Member Price</p>
                    <h3>AED 2000</h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>Event Date</p>
                    <h3>12-06-2025</h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>Event Time</p>
                    <h3>12:00 PM</h3>
                  </div>
                  <div className="rstrnt_lst">
                    <p>No. Of. Guests allowed with a Member</p>
                    <h3>4</h3>
                  </div>
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="btrfly_eft_mn">
              <div className="btrfly_eft_lft">
                <div className="btrfly_eft control_group w_50">
                  <label>Butterfly Effect</label>
                  <IosSwitchMain />
                </div>
                <div className="effts_dscrptn">
                  <p>Description</p>
                  <h3>
                    Savor the Flavors of Sucre: Where Culinary Excellence Meets
                    Creativity
                  </h3>
                </div>
                <div className="cncltn_plcy">
                  <h2>Cancellation Policy</h2>
                  <div className="effts_dscrptn">
                    <p>Cancellation Policy</p>
                    <h3>300 AED</h3>
                  </div>
                  <div className="effts_dscrptn">
                    <p>Cancellation Hours</p>
                    <h3>4 Hours</h3>
                  </div>
                </div>
              </div>
              <div className="btrfly_eft_ryt">
                <figure>
                  <img src="/static/images/dinning.png" alt="" />
                </figure>
                <div className="btrfly_eft_rytcnt">
                  <span>Dinning</span>
                  <h3>The Residence Tunis</h3>
                  <p>
                    Savor the Flavors of Sucre: Where Culinary Excellence Meets
                    Creativity
                  </p>
                </div>
              </div>
            </div>
            <div className="control_group w_100 prfrnc">
              <label>Seating preferences </label>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label="Indoor Seating"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Outdoor Seating"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Indoor Seating"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Outdoor Seating"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Outdoor Seating"
                />
                <FormControlLabel
                  control={<Checkbox />}
                  label="Outdoor Seating"
                />
              </FormGroup>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <BookingHistory hidePast={offerType === "EVENT"} />
          </CustomTabPanel>
        </div>
      </MainContainer>

      <CancelEventModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        setOpen={setOpenModal}
        selectedReason={selectedReason}
        setSelectedReason={setSelectedReason}
      />

      <GenerateLink
        open={openModal2}
        onClose={() => setOpenModal2(false)}
        setOpen={setOpenModal2}
        type="offerManagement"
      />
    </>
  );
}

export default PreviewOfferDetail;
